import { Accordion } from "@app/shared/Accordion"
import { FC, useContext } from "react"
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import ProviderNetworkTypeBadge from "@app/shared/ProviderNetworkTypeBadge";
import { sortProviderNetworkTypes } from "@app/shared/enums/providerNetworkTypeEnum";
import { ProviderBadgeStyle } from "@app/projects/enumerators";
import ProviderActionStatusBadge from "@app/shared/ProviderActionStatusBadge";
import { NO_ACTIONS_APPLIED_LABEL } from "@app/projects/network-assessment/provider-hub/utility";
import { capitalizeFirstLetter } from "@app/shared/utility/capitalizeFirstLetter";

export const HospitalProfileOverview: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const { selectedHospital } = providerHubContext;

  return (
    <Accordion title="Overview" testId="hospital-profile__overview-accordion" defaultOpen={true} className="provider-profile__overview">
      <dl>
        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Facility Type</dt>
          <dd className="provider-profile__overview-value">{selectedHospital.facilityType ? capitalizeFirstLetter(selectedHospital.facilityType) : "Hospital"}</dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Facility CCN</dt>
          <dd className="provider-profile__overview-value">{selectedHospital.ccn}</dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Primary NPI (Type 2)</dt>
          <dd className="provider-profile__overview-value">{selectedHospital.primaryNpi}</dd>
        </div>

        <div className="provider-profile__overview-row--source">
          <dt className="provider-profile__overview-label--source">Source</dt>
          <dd className="provider-profile__overview-value">
            {sortProviderNetworkTypes(selectedHospital.providerNetworkTypes ?? []).map((pt) => (
              <ProviderNetworkTypeBadge badgeStyle={ProviderBadgeStyle.Outline} providerNetworkType={pt} key={pt} />
            ))}
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label--status">Action Status</dt>
          <dd className="provider-profile__overview-value--status">
            {(selectedHospital.providerActionStatuses ?? []).length > 0 ? (
              selectedHospital.providerActionStatuses.map((item) => (
                <ol key={item}>
                  <li><ProviderActionStatusBadge badgeStyle={ProviderBadgeStyle.Dot} status={item} /></li>
                </ol>
              ))
            ) : (
              NO_ACTIONS_APPLIED_LABEL
            )}
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Address</dt>
          <dd className="provider-profile__overview-value">{selectedHospital.address || "---"}</dd>
        </div>
      </dl>
    </Accordion>
  )
};
